import Option from "../../../../Models/forms/Option";
import useCountries from "../../../../http/public/useCountries";

export default (): Option[] =>
  useCountries().map((category) => ({
    value: category.externalId,
    label: category.name,
  }));
